import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { FlexContainer, FlexItem } from '../../styled/layout.styled';

const StyledButton = styled.span`
  cursor: pointer;
  color: #c7baf1;
`;

const StyledFlexContainer = styled(FlexContainer)`
  justify-content: space-around;
  min-width: 153px;
  height: 30px;
  border-radius: 4px;
  background-color: #22096c;
`;

const StyledFlexItem = styled(FlexItem)`
  width: 25px;
  height: 22px;
  cursor: ${({ cursor }) => (cursor ? '' : 'pointer')};
  border-radius: 4px;
  color: #ffffff;
  text-align: center;
  background-color: ${({ current }) => (current ? 'rgba(199, 186, 241, 0.2)' : 'transparent')};
  ${({ ellipsis }) => ellipsis
    ? css`
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        `
    : ''}
`;

const StyledSpan = styled.span`
  width: 25px;
  height: 22px;
  color: #ffffff;
`;

const Pagination = ({
  pagination, prevPage, changePage, nextPage, margin,
}) => (
  <>
    <FlexContainer alignItems="center" justifyContent="center" margin={margin ? '' : '24px 0 0 0'}>
      <StyledButton onClick={e => prevPage(e)}>Prev</StyledButton>
      <StyledFlexContainer margin="0 20px 0 20px" alignItems="center" padding="0 4px 0 4px">
        {pagination.map(({
          id, current, ellipsis, value,
        }) => !ellipsis ? (
          <StyledFlexItem key={id} current={current} onClick={e => changePage(id, e)}>
            <span className="small">{value}</span>
          </StyledFlexItem>
        ) : (
          <StyledFlexItem key={id} cursor="true">
            <StyledSpan className="small">&hellip;</StyledSpan>
          </StyledFlexItem>
        ))}
      </StyledFlexContainer>
      <StyledButton onClick={e => nextPage(e)} className="small">
        Next
      </StyledButton>
    </FlexContainer>
  </>
);

Pagination.propTypes = {
  pagination: PropTypes.arrayOf(PropTypes.any).isRequired,
  prevPage: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  margin: PropTypes.bool,
};

Pagination.defaultProps = {
  margin: false,
};
export default memo(Pagination);
